import styled from 'styled-components';
import { Destination } from '../../types';

interface DestinationIconProps {
  destination: Destination;
  background?: string;
  color?: string;
}
const DestinationIcon = ({
  destination,
  background,
  color
}: DestinationIconProps) => {
  return (
    <Container background={background} color={color}>
      {destination.toUpperCase()}
    </Container>
  );
};

const Container = styled.div<{ background?: string; color?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 10px;
  background-color: ${props =>
    props.background ? props.background : '#e6eff5'};
  border-radius: 360px;
  border: 1px solid #d1d4d9;
  color: ${props => (props.color ? props.color : '#000')};
  font-size: 17px;
  font-family: materialBold;
`;

export default DestinationIcon;
